<script>
import Frame from '@/projects/ocr/components/Frame'

export default {
  props: ['mode', 'tool-options'],
  extends: Frame,
  methods: {
    listen__state__tochange: function (data) {
      const Vue = this
      async function change () {
        if (Vue.mode != 'crop' && data.coord != undefined) {
          Vue.state.coord = {x: data.coord.x, y: data.coord.y}
        }
        if (data.zoom != undefined) {
          Vue.state.zoom = data.zoom
        }
        if (data.voi != undefined) {
          Vue.state.voi = {windowCenter: data.voi.windowCenter, windowWidth: data.voi.windowWidth}
        }
      }
      change()
      Vue.$emit('onstatechange', data)
    },
    addcallback: function (data) {
      const Vue = this;
      Vue.$emit('onadd', data);
    },
    clearToolState: function (toolName) {
      const Vue = this
      Vue.$cornerstoneTools.clearToolState(Vue.$el, toolName)
      Vue.$cornerstone.updateImage(Vue.$el)
    },
    setCropMode: function () {
      const Vue = this
      if (Vue.loaded == true && Vue.frameData._empty == false) {
        Vue.$cornerstoneTools.addToolForElement(Vue.$el, Vue.$cornerstoneTools.CropTool);
        Vue.$cornerstoneTools.setToolActiveForElement(Vue.$el, 'Crop', { mouseButtonMask: 1, colors: Vue.toolOptions.colors, callback: Vue.addcallback})
        Vue.$cornerstone.updateImage(Vue.$el)
      }
    },
    updateTagging: function () {
    },
    update: function () {
      const Vue = this
      if (Vue.loaded == true) {
        const layers = this.$cornerstone.getLayers(this.$el)
        
        for (const layer of layers) {
          Vue.$cornerstone.removeLayer(Vue.$el, layer.layerId)
        }
        
        const image = this.frameData.cornerstoneImage
        let defViewport = this.$cornerstone.getDefaultViewport(this.$el, image)
        const style = getComputedStyle(this.$el)
        const scaleY = parseInt(style.height) / image.height
        const scaleX = parseInt(style.width) / image.width

        this.state = {
          coord: {
            x: 0,
            y: 0
          },
          zoom: (scaleY < scaleX)? scaleY : scaleX,
          voi: {
            windowCenter: 127,
            windowWidth: 256
          }
        }

        defViewport.scale = this.state.zoom
        defViewport.translation.y = this.state.coord.y
        defViewport.translation.x = this.state.coord.x
        defViewport.voi.windowCenter = this.state.voi.windowCenter
        defViewport.voi.windowWidth = this.state.voi.windowWidth
        const imageLayerId = this.$cornerstone.addLayer(this.$el, this.frameData.cornerstoneImage, {viewport: defViewport})
        this.imageLayerId = imageLayerId
        Vue.$cornerstone.updateImage(Vue.$el)
      }
    }
  },
  watch: {
    mode: function (newVal, oldVal) {
      const Vue = this
      if (newVal == 'crop') {
        Vue.setCropMode()
      } else {
        if (oldVal == 'crop' && Vue.loaded == true && Vue.frameData._empty == false) {
          Vue.$cornerstoneTools.clearToolState(Vue.$el, 'Crop')
          Vue.$cornerstoneTools.setToolDisabledForElement(Vue.$el, 'Crop', { mouseButtonMask: 1})
          Vue.$cornerstoneTools.removeToolForElement(Vue.$el, 'Crop');
          Vue.$cornerstone.updateImage(Vue.$el)
        }
      }
    }
  }
}
</script>
